import { AxiosError } from 'axios';

export type PublicFormErrorReason =
  | 'rate_limited'
  | 'verification_failed'
  | 'invalid_data'
  | 'unknown';

// Classifies errors from the public form endpoints (contact, careers), which
// share the same anti-abuse response contract: 429 for throttling, 400 with
// { error: 'Invalid request data' } for Zod validation and
// { error: 'Verification failed' } for a rejected Turnstile token.
export const classifyPublicFormError = (
  error: unknown,
): PublicFormErrorReason => {
  const status =
    error instanceof AxiosError ? error.response?.status : undefined;

  if (status === 429) return 'rate_limited';

  if (status === 400) {
    const errorCode =
      error instanceof AxiosError
        ? (error.response?.data as { error?: string } | undefined)?.error
        : undefined;
    return errorCode === 'Invalid request data'
      ? 'invalid_data'
      : 'verification_failed';
  }

  return 'unknown';
};
